/* Traducciones de la UI nueva de reservas (es/en/pt). Se mergea en translations.js */
const reservationsNew = {
  es: {
    "reservations.editor.editItem": "Editar elemento",
    "reservations.editor.done": "Listo",
    "reservations.dayView.pastBanner": "Día pasado — solo lectura",
    "reservations.dayView.summaryCame": "vinieron",
    "reservations.dayView.summaryCovers": "cubiertos",
    "reservations.dayView.summaryNoShow": "no vinieron",
    "reservations.dayView.statCovers": "cubiertos atendidos",
    "reservations.dayView.statReserved": "Reservaron",
    "reservations.dayView.statCame": "Vinieron",
    "reservations.dayView.statNoShow": "No vinieron",
    "reservations.dayView.statWalkins": "De la calle",
    "reservations.dayView.pastDetailTitle": "Detalle del día",
    "reservations.dayView.walkInTag": "de la calle",
    "reservations.dayView.pastEmptyTitle": "Sin reservas ese día",
    "reservations.dayView.pastEmptyDesc": "No hubo reservas ni clientes registrados en esta fecha.",
    "reservations.today.autoAssigned": "Mesa asignada: {table}",
    "reservations.today.byFranjaLabel": "Cubiertos por horario",
    "reservations.today.reopenTableTaken": "Esa mesa ya está ocupada por otra reserva en ese horario. ¿Reabrir igual? Vas a tener que reasignar la mesa.",
    "reservations.today.reopenOver": "Reabrir esta reserva supera la capacidad de ese horario. ¿Reabrir igual?",
    "reservations.today.confirmReject": "¿Rechazar esta reserva? Se le avisa al cliente por WhatsApp y la reserva se descarta.",
    "reservations.today.confirmNoShow": "¿Marcar como “no vino”? Libera el lugar para otras reservas.",
    "reservations.today.confirmSilent": "¿Confirmar SIN avisarle al cliente por WhatsApp? El cliente no se entera.",
    "reservations.zoneSheet.empty": "Nadie en esta zona todavía",
    "reservations.zoneSheet.walkIn": "Sentar walk-in acá",
    "reservations.config.previewAsClient": "Ver como cliente",
    "reservations.config.waInvalid": "Revisá el número: necesitamos código de área + número (ej: 11 5746-3566). No pongas el 0 ni el 15.",
    "reservations.config.needZone": "Agregá al menos una zona o cambiá el modo a Agenda.",
    "reservations.config.waPreview": "Se usará: {n}",
    "reservations.config.detailsTitle": "Detalles de la reserva",
    "reservations.config.durationTitle": "Duración de cada reserva",
    "reservations.config.durationHint": "Cuánto ocupa la mesa cada reserva. Sirve para no encimar reservas en la misma franja.",
    "reservations.config.slotIntervalTitle": "Cada cuánto se puede reservar (horario libre)",
    "reservations.config.slotIntervalHint": "El paso entre horarios que ve el cliente. Ej.: cada 30 min ofrece 20:00, 20:30, 21:00… (en vez de cada 15). Solo aplica a los días en modo \"horario libre\".",
    "reservations.config.everyN": "Cada {n}",
    "reservations.config.intervalAny": "Cualquier horario",
    "reservations.book.openHoursHint": "Horario de atención: {hours}",
    "reservations.book.outOfHoursPick": "Ese horario está fuera del horario de atención. Elegí uno dentro.",
    "reservations.book.tooSoonPick": "Ese horario ya pasó o es muy pronto. Elegí uno más adelante.",
    "reservations.config.minAdvanceTitle": "Anticipación mínima para reservar",
    "reservations.config.minAdvanceHint": "Con cuánta anticipación mínima te pueden reservar para hoy. Los horarios que ya pasaron nunca se muestran.",
    "reservations.config.advanceNone": "Sin mínimo",
    "reservations.config.advanceDay": "1 día",
    "reservations.config.windowTitle": "Con cuánta anticipación pueden reservar",
    "reservations.config.windowHint": "Hasta cuántos días para adelante te pueden reservar tus clientes.",
    "reservations.config.capacityTitle": "Cupo de personas en simultáneo",
    "reservations.config.capacityHint": "Tope de cubiertos al mismo tiempo. 0 = sin límite. Te avisamos al confirmar/cargar si lo superás.",
    "reservations.config.capacityPlaceholder": "Sin límite",
    "reservations.config.daysUnit": "días",
    "reservations.alert.aria": "Nueva reserva",
    "reservations.alert.more": "(+{n} más)",
    "reservations.alert.title": "¡Nueva reserva!",
    "reservations.book.anyZone": "Cualquier zona / me da igual",
    "reservations.book.approxDuration": "(aprox. {n} min)",
    "reservations.book.heldRange": "Te apartamos el horario de {start} a {end}",
    "reservations.book.consultCta": "¿No encontrás lugar u horario? Consultanos",
    "reservations.today.tightTurnaroundWarn": "Esta mesa queda muy pegada a otra reserva (poco margen para preparar). ¿Confirmar igual?",
    "reservations.today.pendingOtherDays": "⏳ {n} por confirmar de otros días",
    "reservations.today.pendingSheetTitle": "Reservas por confirmar",
    "reservations.today.pendingSheetEmpty": "No hay reservas por confirmar.",
    "reservations.book.consultWaMessage": "¡Hola! Quería consultar disponibilidad para una reserva 🙌",
    "reservations.book.expand": "Ampliar",
    "reservations.book.enlarge": "Ampliar",
    "reservations.tableGrid.tableN": "Mesa {n}",
    "reservations.nav.today": "Hoy",
    "reservations.nav.calendar": "Calendario",
    "reservations.nav.tables": "Mesas",
    "reservations.nav.summary": "Resumen",
    "reservations.nav.clients": "Clientes",
    "reservations.clients.title": "Clientes",
    "reservations.clients.subtitle": "Tu base de clientes",
    "reservations.clients.count": "{n} clientes",
    "reservations.clients.searchPh": "Buscar por nombre o teléfono",
    "reservations.clients.empty": "Todavía no hay clientes. Se cargan solos a medida que recibís reservas.",
    "reservations.clients.noMatch": "Ningún cliente coincide con la búsqueda.",
    "reservations.clients.visits": "Visitas",
    "reservations.clients.noShows": "No vino",
    "reservations.clients.covers": "Cubiertos",
    "reservations.clients.visitsN": "{n} visitas",
    "reservations.clients.noShowN": "{n} no vino",
    "reservations.clients.last": "última: {date}",
    "reservations.clients.lastVisit": "Última visita",
    "reservations.clients.wa": "WhatsApp",
    "reservations.clients.call": "Llamar",
    "reservations.clients.makeVip": "VIP",
    "reservations.clients.notes": "Notas",
    "reservations.clients.notesPh": "Ej: mesa preferida, cliente habitual, alérgico a…",
    "reservations.clients.save": "Guardar nota",
    "reservations.clients.saved": "Guardado",
    "reservations.clients.saveError": "No se pudo guardar",
    "reservations.clients.waHi": "¡Hola! 👋",
    "reservations.waitlist.open": "Lista de espera",
    "reservations.waitlist.title": "Lista de espera",
    "reservations.waitlist.nameLabel": "Nombre (opcional)",
    "reservations.waitlist.phoneLabel": "Teléfono para avisar (opcional)",
    "reservations.waitlist.namePh": "Ej: Lucas",
    "reservations.waitlist.phonePh": "Ej: +54 9 11 2243 0883",
    "reservations.waitlist.add": "Agregar a la espera",
    "reservations.waitlist.empty": "Nadie esperando. Agregá a quien se quede sin mesa.",
    "reservations.waitlist.guest": "Sin nombre",
    "reservations.waitlist.notify": "Avisar",
    "reservations.waitlist.waitedMin": "hace {n} min",
    "reservations.waitlist.waMsg": "¡Hola{name}! Se liberó una mesa en {place}. ¿Seguís con ganas? Avisanos 🙌",
    "reservations.manage.eyebrow": "Tu reserva",
    "reservations.manage.yourBooking": "Tu reserva",
    "reservations.manage.loading": "Cargando…",
    "reservations.manage.invalidTitle": "Link inválido",
    "reservations.manage.invalidDesc": "Este link no es válido o la reserva ya no existe. Si necesitás, escribinos por WhatsApp.",
    "reservations.manage.date": "Fecha",
    "reservations.manage.time": "Hora",
    "reservations.manage.people": "Personas",
    "reservations.manage.table": "Mesa",
    "reservations.manage.confirmCta": "Confirmar que voy",
    "reservations.manage.cancelCta": "Cancelar reserva",
    "reservations.manage.cancelConfirm": "¿Seguro que querés cancelar tu reserva?\n\nApenas confirmes se va a abrir WhatsApp con un mensaje ya escrito para avisarle al restaurante. Por favor, entrá y enviá ese mensaje.",
    "reservations.manage.cancelledMsg": "Tu reserva quedó cancelada. ¡Gracias por avisar!",
    "reservations.manage.notifyRestaurant": "Avisar al restaurante",
    "reservations.manage.cancelWaHeadsUp": "Te abrimos WhatsApp para avisarle al restaurante 👇 Por favor, enviá el mensaje (no lo cierres sin enviarlo).",
    "reservations.manage.cancelWaMessage": "¡Hola! Cancelé mi reserva a nombre de {name} para el {date} a las {time} ({people} personas). ¡Gracias!",
    "reservations.manage.confirmedMsg": "¡Listo! Confirmaste tu reserva. Te esperamos 🙌",
    "reservations.manage.error": "No se pudo procesar. Probá de nuevo.",
    "reservations.nav.settings": "Config",
    "reservations.book.placePhotosTitle": "Conocé el lugar",
    "reservations.book.placePhotosHint": "Tocá una foto para verla en grande. Podés deslizar entre todas.",
    "reservations.book.sector": "Sector",
    "reservations.book.photoFailed": "No se pudo cargar la foto.",
    "reservations.book.legendFree": "Libre (tocá para elegir)",
    "reservations.book.legendChosen": "Tu mesa",
    "reservations.book.legendTooSmall": "No entra tu grupo",
    "reservations.book.legendUnavailable": "No disponible",
    "reservations.book.viewPhoto": "Ver foto",
    "reservations.book.zoneStep": "¿En qué zona?",
    "reservations.config.chosen": "Elegiste: {mode}",
    "reservations.config.enabledHint": "Cuando está activo, tus clientes pueden reservar desde el link público.",
    "reservations.config.enabledTitle": "Reservas activas",
    "reservations.config.groupPage": "Tu página de reservas",
    "reservations.config.groupPageDesc": "Lo que ve tu cliente cuando abre el link para reservar.",
    "reservations.config.groupSpace": "Cómo organizás el lugar",
    "reservations.config.groupSpaceDesc": "Elegí cómo tomás las reservas: agenda simple, por zonas o con plano de mesas.",
    "reservations.config.groupHours": "Cuándo abrís",
    "reservations.config.groupHoursDesc": "Tus horarios de atención, los días que cerrás y los feriados que abrís.",
    "reservations.config.advanced": "Ajustes avanzados",
    "reservations.config.leaveUnsaved": "Tenés cambios sin guardar. ¿Salir igual y perderlos?",
    "reservations.config.photoTitle": "Logo del local",
    "reservations.config.photoHint": "Se muestra arriba en tu página de reservas. Subí el logo de tu local.",
    "reservations.config.photoAdd": "Subir logo",
    "reservations.config.photoChange": "Cambiar logo",
    "reservations.config.photoRemove": "Quitar",
    "reservations.config.uploading": "Subiendo…",
    "reservations.config.mode.agendaExample": "Tenés un bar o café chico. Te escriben \"mesa para 4 a las 21\" y queda anotado solo. Ves la lista del día y marcás quién llegó de un toque. Nada más.",
    "reservations.config.mode.agendaNeeds": "No necesitás configurar nada más.",
    "reservations.config.mode.agendaShort": "Solo anotás quién viene. Sin mapa ni mesas.",
    "reservations.config.mode.agendaTitle": "Agenda simple",
    "reservations.config.mode.hide": "Ocultar",
    "reservations.config.mode.showHow": "Ver cómo se usa",
    "reservations.config.mode.tablesExample": "Tu salón es estable. Dibujás el plano una vez. El cliente puede pedir una mesa puntual y vos asignás mesa a cada reserva. Ves el mapa con las mesas libres y ocupadas en vivo.",
    "reservations.config.mode.tablesNeeds": "Dibujás el plano de mesas una vez.",
    "reservations.config.mode.tablesShort": "Cada reserva queda atada a una mesa puntual del plano.",
    "reservations.config.mode.tablesTitle": "Mesas fijas",
    "reservations.config.mode.zonesExample": "Movés las mesas según el día. El cliente pide \"4 personas en el deck\". Vos ves cuánto lugar queda en cada zona y confirmás si podés armar algo. La reserva queda atada a la zona, no a una mesa.",
    "reservations.config.mode.zonesNeeds": "Definís tus zonas y, si querés, su capacidad.",
    "reservations.config.mode.zonesShort": "Reservás por zona (deck, salón, patio) y vos armás las mesas.",
    "reservations.config.mode.zonesTitle": "Por zonas",
    "reservations.config.openMapEditor": "Abrir editor de plano",
    "reservations.config.spaceModeHint": "Cómo gestionás el espacio. Cambiarlo no borra reservas existentes.",
    "reservations.config.confirmModeChange": "¿Cambiar el modo de reservas? Las mesas/zonas y reservas ya cargadas en el modo actual pueden dejar de mostrarse. Las reservas no se borran.",
    "reservations.config.spaceModeTitle": "Modo de reservas",
    "reservations.config.start": "Empezar",
    "reservations.config.tablesHint": "Dibujá tu salón: mesas, capacidad y ubicación.",
    "reservations.config.tablesTitle": "Plano de mesas",
    "reservations.config.welcomeSub": "Elegí el modo que más se parezca a cómo trabajás. Podés cambiarlo después sin perder nada.",
    "reservations.config.welcomeTitle": "¿Cómo preferís manejar tus reservas?",
    "reservations.config.zones.addPhoto": "Agregar foto",
    "reservations.config.zones.addZone": "Agregar zona",
    "reservations.config.zones.empty": "Todavía no tenés zonas. Agregá las que uses (Deck, Salón, Patio…).",
    "reservations.config.zones.hint": "La capacidad es opcional: si la ponés, te avisamos cuando una zona se pasa de cupo (no bloquea — vos decidís). La foto la ve el cliente al elegir zona.",
    "reservations.config.zones.namePlaceholder": "Nombre de la zona",
    "reservations.config.zones.confirmDelete": "¿Borrar esta zona? Las reservas que ya estén en ella no se borran.",
    "reservations.config.zones.peopleUnit": "pers.",
    "reservations.config.zones.photoAlt": "zona",
    "reservations.config.zones.removePhoto": "Quitar foto",
    "reservations.config.zones.removeZone": "Eliminar zona",
    "reservations.config.zones.sectionHint": "Las áreas donde sentás gente (Deck, Salón, Patio…).",
    "reservations.config.zones.sectionTitle": "Tus zonas",
    "reservations.config.zones.uploading": "Subiendo…",
    "reservations.map.legendFree": "Libre",
    "reservations.map.legendOccupied": "Ocupada",
    "reservations.map.legendPending": "Pendiente",
    "reservations.map.legendReserved": "Reservada",
    "reservations.map.noFloorPlanDesc": "Andá a Configuración → Plano de mesas para crearlo.",
    "reservations.map.noFloorPlanTitle": "Todavía no dibujaste tu plano",
    "reservations.map.noZonesDesc": "Andá a Configuración → Tus zonas para crearlas.",
    "reservations.map.noZonesTitle": "Todavía no definiste zonas",
    "reservations.map.zoneCapacity": "{used} / {cap} personas",
    "reservations.map.zoneUsage": "{people} personas · {parties} grupos",
    "reservations.row.actionArrived": "Llegó",
    "reservations.row.actionConfirm": "Confirmar",
    "reservations.row.actionConfirmNotify": "Confirmar y avisar",
    "reservations.row.actionConfirmSilent": "Confirmar sin avisar",
    "reservations.row.noteLabel": "Nota",
    "reservations.row.actionEdit": "Editar",
    "reservations.row.actionFree": "Liberar mesa",
    "reservations.row.actionNoShow": "No vino",
    "reservations.row.actionReject": "Rechazar",
    "reservations.row.actionRemind": "Recordar",
    "reservations.row.actionAssign": "Mesa",
    "reservations.row.actionCancel": "Cancelar",
    "reservations.row.actionReopen": "Recuperar",
    "reservations.row.anyZone": "Cualquier zona",
    "reservations.row.badgeMissed": "faltó {n}",
    "reservations.row.badgeCollision": "Choca con {name} (misma mesa y horario)",
    "reservations.row.badgeNew": "nueva",
    "reservations.row.confirmedByGuest": "confirmó",
    "reservations.row.confirmedByGuestHint": "El cliente confirmó su asistencia desde el link que le mandaste.",
    "reservations.row.emptyTitle": "Nada por acá",
    "reservations.row.groupClosed": "Cerradas",
    "reservations.row.groupIncoming": "Por llegar",
    "reservations.row.groupSeated": "En mesa",
    "reservations.row.rosterEmptyText": "Las confirmadas y las que ya están en mesa van a aparecer acá.",
    "reservations.row.rosterEmptyTitle": "Sin reservas en el roster",
    "reservations.row.statusArrived": "En mesa",
    "reservations.row.statusCancelled": "Cancelada",
    "reservations.row.statusDeparted": "Se fue",
    "reservations.row.statusConfirmed": "Confirmada",
    "reservations.row.statusNoShow": "No vino",
    "reservations.row.statusPending": "Pendiente",
    "reservations.row.statusRejected": "Rechazada",
    "reservations.row.table": "Mesa {x}",
    "reservations.share.copied": "Copiado",
    "reservations.share.copy": "Copiar link",
    "reservations.share.intro": "Este es el link para que tus clientes reserven. Compartilo por WhatsApp, Instagram, en tu carta, donde quieras.",
    "reservations.share.title": "Compartir link de reservas",
    "reservations.share.waButton": "Compartir por WhatsApp",
    "reservations.share.waText": "¡Reservá tu mesa acá!",
    "reservations.sheet.anyZone": "Cualquier zona",
    "reservations.sheet.arrived": "Llegó",
    "reservations.sheet.atTable": "En mesa",
    "reservations.sheet.atWhatTime": "¿A qué hora?",
    "reservations.sheet.durationLabel": "¿Cuánto dura?",
    "reservations.sheet.confirm": "Confirmar",
    "reservations.sheet.createBooking": "Cargar reserva",
    "reservations.sheet.editTitle": "Editar reserva",
    "reservations.sheet.howManyPeople": "¿Cuántas personas?",
    "reservations.sheet.inWhichZone": "¿En qué zona?",
    "reservations.sheet.pickZoneFirst": "Elegí la zona primero.",
    "reservations.sheet.less": "Menos",
    "reservations.sheet.more": "Más",
    "reservations.sheet.name": "Nombre",
    "reservations.sheet.newTitle": "Nueva reserva",
    "reservations.sheet.noteOptional": "Nota (opcional)",
    "reservations.sheet.notePlaceholder": "Ej: cumpleaños, cerca de la ventana…",
    "reservations.sheet.offline": "Sin conexión — los cambios se guardan y se sincronizan solos",
    "reservations.sheet.people": "Personas",
    "reservations.sheet.phone": "Teléfono",
    "reservations.sheet.phoneOptional": "Teléfono (opcional)",
    "reservations.sheet.reopen": "Reabrir",
    "reservations.sheet.saveChanges": "Guardar cambios",
    "reservations.sheet.searchEmpty": "No encontré nada con \"{q}\".",
    "reservations.sheet.searchIntro": "Cuando llega alguien, buscalo por nombre o teléfono y marcá que llegó.",
    "reservations.sheet.searchPlaceholder": "Nombre o teléfono…",
    "reservations.sheet.searchTitle": "Buscar reserva",
    "reservations.sheet.seatN": "Sentar {n} personas",
    "reservations.sheet.seatOne": "Sentar 1 persona",
    "reservations.sheet.table": "Mesa",
    "reservations.sheet.tableN": "Mesa {n}",
    "reservations.sheet.tableOptional": "Mesa (opcional)",
    "reservations.sheet.walkInTitle": "Sin reserva",
    "reservations.row.assignSpot": "Asignar lugar",
    "reservations.sheet.spotTitle": "¿En qué mesa o lugar?",
    "reservations.sheet.spotHint": "Anotá dónde la vas a sentar para saberlo cuando llegue. Es texto libre.",
    "reservations.sheet.spotPlaceholder": "Ej: Mesa 5, ventana, fondo…",
    "reservations.sheet.spotSave": "Guardar lugar",
    "reservations.sheet.spotClear": "Sacar el lugar",
    "reservations.today.spotSaved": "Lugar guardado: {spot}",
    "reservations.today.spotCleared": "Lugar quitado",
    "reservations.sheet.whichTable": "¿Qué mesa?",
    "reservations.sheet.changeTable": "Cambiar mesa",
    "reservations.sheet.zone": "Zona",
    "reservations.today.activate": "Activar",
    "reservations.today.backToMenu": "Volver al menú",
    "reservations.today.prevDay": "Día anterior",
    "reservations.today.nextDay": "Día siguiente",
    "reservations.today.blockTable": "Bloquear mesa",
    "reservations.today.chipBookings": "Reservas",
    "reservations.today.chipCovers": "Cubiertos",
    "reservations.today.chipSeated": "En mesa",
    "reservations.today.disabledNotice": "Reservas desactivadas — tus clientes no pueden reservar.",
    "reservations.today.emptyArrivingText": "Las reservas confirmadas que faltan llegar aparecen acá.",
    "reservations.today.emptyArrivingTitle": "Nadie por llegar",
    "reservations.today.emptyClosedText": "No-shows, canceladas y rechazadas van a aparecer acá.",
    "reservations.today.emptyClosedTitle": "Ninguna cerrada hoy",
    "reservations.today.emptySeatedText": "Cuando marques que alguien llegó, aparece acá.",
    "reservations.today.emptySeatedTitle": "No hay nadie en mesa",
    "reservations.today.live": "En vivo",
    "reservations.today.liveService": "Servicio en vivo",
    "reservations.today.loading": "Cargando…",
    "reservations.today.navConfig": "Config",
    "reservations.today.navMonth": "Calendario",
    "reservations.today.navStats": "Métricas",
    "reservations.today.newBooking": "Reserva",
    "reservations.today.onboardCta": "Empezar",
    "reservations.today.onboardSub": "Elegí cómo querés manejarlas y activá el link para tus clientes.",
    "reservations.today.onboardTitle": "Configurá tus reservas",
    "reservations.today.search": "Buscar",
    "reservations.today.shareLink": "Compartir link",
    "reservations.today.guideTitle": "Descubrí cómo se usa",
    "reservations.today.guideSub": "Guía rápida del sistema de reservas (PDF)",
    "reservations.today.guideDismiss": "Cerrar",
    "reservations.today.tabArriving": "Por llegar",
    "reservations.today.filterAll": "Todas",
    "reservations.today.filterSoon": "Próxima hora",
    "reservations.today.filterEmpty": "No hay reservas con este filtro",
    "reservations.today.tabPending": "Pendientes",
    "reservations.today.tabClosed": "Cerradas",
    "reservations.today.tabMap": "Mapa",
    "reservations.today.tabTimeline": "Línea",
    "reservations.timeline.noTables": "Dibujá tu plano de mesas para ver la línea de tiempo.",
    "reservations.timeline.empty": "No hay horario configurado para este día.",
    "reservations.timeline.tableShort": "Mesa",
    "reservations.timeline.blocked": "Bloqueada",
    "reservations.timeline.hint": "Tocá una reserva para confirmarla, marcar que llegó, etc. La línea roja es la hora actual.",
    "reservations.timeline.bookingTitle": "Reserva",
    "reservations.today.tabSeated": "En mesa",
    "reservations.today.toastSaveError": "No se pudo guardar la reserva",
    "reservations.today.toastUpdateError": "No se pudo actualizar la reserva",
    "reservations.today.toastWalkInError": "No se pudo cargar el walk-in",
    "reservations.today.toastWalkInOk": "Sentado sin reserva",
    "reservations.today.toastWalkInOkAt": "Sentado en {where}",
    "reservations.today.toastBookingSaved": "Reserva guardada",
    "reservations.today.toastBookingUpdated": "Reserva actualizada",
    "reservations.today.toastCancelled": "Reserva cancelada",
    "reservations.today.confirmCancel": "¿Cancelar esta reserva? Es una baja limpia (no cuenta como falta del cliente).",
    "reservations.today.toConfirm": "Por confirmar",
    "reservations.today.todayLabel": "Hoy",
    "reservations.today.walkIn": "Sin reserva",
    "reservations.past.title": "Resumen del día",
    "reservations.past.came": "Vinieron",
    "reservations.past.noShow": "No vinieron",
    "reservations.past.walkins": "Sin reserva",
    "reservations.past.unmarked": "Sin marcar",
    "reservations.past.covers": "Cubiertos",
    "reservations.past.empty": "No hubo reservas este día.",
    "reservations.past.walkinGuest": "Sin reserva",
    "reservations.today.walkInSeatAnyway": "¿Sentás igual?",
    "reservations.today.walkInTableBusy": "Esa mesa ya está ocupada en este horario.",
    "reservations.today.walkInZoneFull": "Esa zona está cerca o pasada de su capacidad.",
  },
  en: {
    "reservations.editor.editItem": "Edit item",
    "reservations.editor.done": "Done",
    "reservations.dayView.pastBanner": "Past day — read-only",
    "reservations.dayView.summaryCame": "came",
    "reservations.dayView.summaryCovers": "covers",
    "reservations.dayView.summaryNoShow": "no-shows",
    "reservations.dayView.statCovers": "covers served",
    "reservations.dayView.statReserved": "Booked",
    "reservations.dayView.statCame": "Showed up",
    "reservations.dayView.statNoShow": "No-shows",
    "reservations.dayView.statWalkins": "Walk-ins",
    "reservations.dayView.pastDetailTitle": "Day detail",
    "reservations.dayView.walkInTag": "walk-in",
    "reservations.dayView.pastEmptyTitle": "No bookings that day",
    "reservations.dayView.pastEmptyDesc": "There were no reservations or guests recorded on this date.",
    "reservations.today.autoAssigned": "Table assigned: {table}",
    "reservations.today.byFranjaLabel": "Covers by time",
    "reservations.today.reopenTableTaken": "That table is already taken by another booking at that time. Reopen anyway? You'll need to reassign the table.",
    "reservations.today.reopenOver": "Reopening this booking goes over capacity for that time. Reopen anyway?",
    "reservations.today.confirmReject": "Reject this booking? The guest is notified on WhatsApp and the booking is discarded.",
    "reservations.today.confirmNoShow": "Mark as no-show? This frees the spot for other bookings.",
    "reservations.today.confirmSilent": "Confirm WITHOUT messaging the guest on WhatsApp? They won't be notified.",
    "reservations.zoneSheet.empty": "Nobody in this area yet",
    "reservations.zoneSheet.walkIn": "Seat a walk-in here",
    "reservations.config.previewAsClient": "Preview as customer",
    "reservations.config.waInvalid": "Looks incomplete. Include the country code (e.g. 1415…).",
    "reservations.config.needZone": "Add at least one zone or switch the mode to Agenda.",
    "reservations.config.waPreview": "Will use: {n}",
    "reservations.config.detailsTitle": "Booking details",
    "reservations.config.durationTitle": "Length of each booking",
    "reservations.config.durationHint": "How long a table is held per booking. Used to avoid overlapping bookings in the same slot.",
    "reservations.config.slotIntervalTitle": "How often they can book (free hours)",
    "reservations.config.slotIntervalHint": "The step between times the customer sees. E.g. every 30 min offers 8:00, 8:30, 9:00… (instead of every 15). Only applies to days in \"free hours\" mode.",
    "reservations.config.everyN": "Every {n}",
    "reservations.config.intervalAny": "Any time",
    "reservations.book.openHoursHint": "Open hours: {hours}",
    "reservations.book.outOfHoursPick": "That time is outside opening hours. Please pick one within.",
    "reservations.book.tooSoonPick": "That time already passed or is too soon. Please pick a later one.",
    "reservations.config.minAdvanceTitle": "Minimum notice to book",
    "reservations.config.minAdvanceHint": "The least time ahead customers can book for today. Times that already passed are never shown.",
    "reservations.config.advanceNone": "No minimum",
    "reservations.config.advanceDay": "1 day",
    "reservations.config.windowTitle": "How far ahead they can book",
    "reservations.config.windowHint": "How many days ahead your customers can book.",
    "reservations.config.capacityTitle": "Max guests at the same time",
    "reservations.config.capacityHint": "Cap on covers at once. 0 = no limit. We warn you when confirming/adding if you go over.",
    "reservations.config.capacityPlaceholder": "No limit",
    "reservations.config.daysUnit": "days",
    "reservations.alert.aria": "New booking",
    "reservations.alert.more": "(+{n} more)",
    "reservations.alert.title": "New booking!",
    "reservations.book.anyZone": "Any area / no preference",
    "reservations.book.approxDuration": "(approx. {n} min)",
    "reservations.book.heldRange": "We'll hold {start}–{end} for you",
    "reservations.book.consultCta": "Can't find a spot or time? Get in touch",
    "reservations.today.tightTurnaroundWarn": "This table is very tight against another booking (little time to turn it over). Confirm anyway?",
    "reservations.today.pendingOtherDays": "⏳ {n} to confirm on other days",
    "reservations.today.pendingSheetTitle": "Bookings to confirm",
    "reservations.today.pendingSheetEmpty": "No bookings to confirm.",
    "reservations.book.consultWaMessage": "Hi! I'd like to check availability for a reservation 🙌",
    "reservations.book.expand": "Enlarge",
    "reservations.book.enlarge": "Enlarge",
    "reservations.tableGrid.tableN": "Table {n}",
    "reservations.nav.today": "Today",
    "reservations.nav.calendar": "Calendar",
    "reservations.nav.tables": "Tables",
    "reservations.nav.summary": "Summary",
    "reservations.nav.clients": "Guests",
    "reservations.clients.title": "Guests",
    "reservations.clients.subtitle": "Your guest database",
    "reservations.clients.count": "{n} guests",
    "reservations.clients.searchPh": "Search by name or phone",
    "reservations.clients.empty": "No guests yet. They build up automatically as you get bookings.",
    "reservations.clients.noMatch": "No guest matches your search.",
    "reservations.clients.visits": "Visits",
    "reservations.clients.noShows": "No-shows",
    "reservations.clients.covers": "Covers",
    "reservations.clients.visitsN": "{n} visits",
    "reservations.clients.noShowN": "{n} no-show",
    "reservations.clients.last": "last: {date}",
    "reservations.clients.lastVisit": "Last visit",
    "reservations.clients.wa": "WhatsApp",
    "reservations.clients.call": "Call",
    "reservations.clients.makeVip": "VIP",
    "reservations.clients.notes": "Notes",
    "reservations.clients.notesPh": "e.g. favorite table, regular, allergic to…",
    "reservations.clients.save": "Save note",
    "reservations.clients.saved": "Saved",
    "reservations.clients.saveError": "Couldn't save",
    "reservations.clients.waHi": "Hi! 👋",
    "reservations.waitlist.open": "Waitlist",
    "reservations.waitlist.title": "Waitlist",
    "reservations.waitlist.nameLabel": "Name (optional)",
    "reservations.waitlist.phoneLabel": "Phone to notify (optional)",
    "reservations.waitlist.namePh": "e.g. Lucas",
    "reservations.waitlist.phonePh": "e.g. +1 555 123 4567",
    "reservations.waitlist.add": "Add to waitlist",
    "reservations.waitlist.empty": "Nobody waiting. Add anyone left without a table.",
    "reservations.waitlist.guest": "No name",
    "reservations.waitlist.notify": "Notify",
    "reservations.waitlist.waitedMin": "{n} min ago",
    "reservations.waitlist.waMsg": "Hi{name}! A table just opened up at {place}. Still interested? Let us know 🙌",
    "reservations.manage.eyebrow": "Your booking",
    "reservations.manage.yourBooking": "Your booking",
    "reservations.manage.loading": "Loading…",
    "reservations.manage.invalidTitle": "Invalid link",
    "reservations.manage.invalidDesc": "This link isn't valid or the booking no longer exists. Feel free to message us on WhatsApp.",
    "reservations.manage.date": "Date",
    "reservations.manage.time": "Time",
    "reservations.manage.people": "Guests",
    "reservations.manage.table": "Table",
    "reservations.manage.confirmCta": "Confirm I'm coming",
    "reservations.manage.cancelCta": "Cancel booking",
    "reservations.manage.cancelConfirm": "Are you sure you want to cancel your booking?\n\nRight after you confirm, WhatsApp will open with a ready-made message to notify the restaurant. Please open it and send that message.",
    "reservations.manage.cancelledMsg": "Your booking is cancelled. Thanks for letting us know!",
    "reservations.manage.notifyRestaurant": "Notify the restaurant",
    "reservations.manage.cancelWaHeadsUp": "We opened WhatsApp so you can notify the restaurant 👇 Please send the message (don't close it without sending).",
    "reservations.manage.cancelWaMessage": "Hi! I cancelled my booking under {name} for {date} at {time} ({people} people). Thanks!",
    "reservations.manage.confirmedMsg": "Done! You confirmed your booking. See you 🙌",
    "reservations.manage.error": "Couldn't process it. Please try again.",
    "reservations.nav.settings": "Settings",
    "reservations.book.placePhotosTitle": "See the place",
    "reservations.book.placePhotosHint": "Tap a photo to view it large. Swipe through them all.",
    "reservations.book.sector": "Area",
    "reservations.book.photoFailed": "Couldn't load the photo.",
    "reservations.book.legendFree": "Available (tap to select)",
    "reservations.book.legendChosen": "Your table",
    "reservations.book.legendTooSmall": "Too small for your party",
    "reservations.book.viewPhoto": "View photo",
    "reservations.book.legendUnavailable": "Unavailable",
    "reservations.book.zoneStep": "Which area?",
    "reservations.config.chosen": "You chose: {mode}",
    "reservations.config.enabledHint": "When it's on, your guests can book from your public link.",
    "reservations.config.enabledTitle": "Reservations on",
    "reservations.config.groupPage": "Your booking page",
    "reservations.config.groupPageDesc": "What your guests see when they open your booking link.",
    "reservations.config.groupSpace": "How you organize the place",
    "reservations.config.groupSpaceDesc": "Choose how you take bookings: a simple list, by area, or with a table map.",
    "reservations.config.groupHours": "When you're open",
    "reservations.config.groupHoursDesc": "Your opening hours, the days you're closed, and the holidays you open.",
    "reservations.config.advanced": "Advanced settings",
    "reservations.config.leaveUnsaved": "You have unsaved changes. Leave anyway and lose them?",
    "reservations.config.photoTitle": "Your logo",
    "reservations.config.photoHint": "Shown at the top of your booking page. Upload your logo.",
    "reservations.config.photoAdd": "Upload logo",
    "reservations.config.photoChange": "Change logo",
    "reservations.config.photoRemove": "Remove",
    "reservations.config.uploading": "Uploading…",
    "reservations.config.mode.agendaExample": "You run a small bar or café. Someone messages \"table for 4 at 9pm\" and it's logged, that's it. You see the day's list and tap to mark who showed up. Nothing else.",
    "reservations.config.mode.agendaNeeds": "Nothing else to set up.",
    "reservations.config.mode.agendaShort": "Just jot down who's coming. No map, no tables.",
    "reservations.config.mode.agendaTitle": "Simple list",
    "reservations.config.mode.hide": "Hide",
    "reservations.config.mode.showHow": "See how it works",
    "reservations.config.mode.tablesExample": "Your room stays the same. You draw the layout once. Guests can request a specific table and you assign one to every booking. You see the map with free and taken tables live.",
    "reservations.config.mode.tablesNeeds": "Draw your table layout once.",
    "reservations.config.mode.tablesShort": "Each booking is tied to a specific table on your layout.",
    "reservations.config.mode.tablesTitle": "Fixed tables",
    "reservations.config.mode.zonesExample": "You move tables around depending on the day. A guest asks for \"4 people on the deck\". You see how much room is left in each area and confirm if you can make it work. The booking is tied to the area, not a specific table.",
    "reservations.config.mode.zonesNeeds": "Set up your areas and, if you want, their capacity.",
    "reservations.config.mode.zonesShort": "Book by area (deck, dining room, patio) and you arrange the tables.",
    "reservations.config.mode.zonesTitle": "By area",
    "reservations.config.openMapEditor": "Open layout editor",
    "reservations.config.spaceModeHint": "How you manage your space. Changing it won't delete existing reservations.",
    "reservations.config.confirmModeChange": "Change the reservation mode? Tables/zones and bookings set up in the current mode may stop showing. Existing reservations are not deleted.",
    "reservations.config.spaceModeTitle": "Reservation mode",
    "reservations.config.start": "Get started",
    "reservations.config.tablesHint": "Map out your room: tables, capacity and where they sit.",
    "reservations.config.tablesTitle": "Table layout",
    "reservations.config.welcomeSub": "Pick the mode that best matches how you work. You can change it later without losing anything.",
    "reservations.config.welcomeTitle": "How would you like to handle your reservations?",
    "reservations.config.zones.addPhoto": "Add photo",
    "reservations.config.zones.addZone": "Add area",
    "reservations.config.zones.empty": "You don't have any areas yet. Add the ones you use (Deck, Dining room, Patio…).",
    "reservations.config.zones.hint": "Capacity is optional: if you set it, we'll let you know when an area goes over (it won't block anything — you decide). Guests see the photo when picking an area.",
    "reservations.config.zones.namePlaceholder": "Area name",
    "reservations.config.zones.confirmDelete": "Delete this area? Bookings already in it are not deleted.",
    "reservations.config.zones.peopleUnit": "ppl",
    "reservations.config.zones.photoAlt": "area",
    "reservations.config.zones.removePhoto": "Remove photo",
    "reservations.config.zones.removeZone": "Remove area",
    "reservations.config.zones.sectionHint": "The spots where you seat guests (Deck, Dining room, Patio…).",
    "reservations.config.zones.sectionTitle": "Your areas",
    "reservations.config.zones.uploading": "Uploading…",
    "reservations.map.legendFree": "Free",
    "reservations.map.legendOccupied": "Occupied",
    "reservations.map.legendPending": "Pending",
    "reservations.map.legendReserved": "Reserved",
    "reservations.map.noFloorPlanDesc": "Go to Settings → Floor plan to create it.",
    "reservations.map.noFloorPlanTitle": "You haven't drawn your floor plan yet",
    "reservations.map.noZonesDesc": "Go to Settings → Your areas to create them.",
    "reservations.map.noZonesTitle": "You haven't set up any areas yet",
    "reservations.map.zoneCapacity": "{used} / {cap} guests",
    "reservations.map.zoneUsage": "{people} guests · {parties} parties",
    "reservations.row.actionArrived": "Arrived",
    "reservations.row.actionConfirm": "Confirm",
    "reservations.row.actionConfirmNotify": "Confirm & notify",
    "reservations.row.actionConfirmSilent": "Confirm without notifying",
    "reservations.row.noteLabel": "Note",
    "reservations.row.actionEdit": "Edit",
    "reservations.row.actionFree": "Free table",
    "reservations.row.actionNoShow": "No-show",
    "reservations.row.actionReject": "Reject",
    "reservations.row.actionRemind": "Remind",
    "reservations.row.actionAssign": "Table",
    "reservations.row.actionCancel": "Cancel",
    "reservations.row.actionReopen": "Restore",
    "reservations.row.anyZone": "Any area",
    "reservations.row.badgeMissed": "missed {n}",
    "reservations.row.badgeCollision": "Clashes with {name} (same table & time)",
    "reservations.row.badgeNew": "new",
    "reservations.row.confirmedByGuest": "confirmed",
    "reservations.row.confirmedByGuestHint": "The guest confirmed they're coming via the link you sent.",
    "reservations.row.emptyTitle": "Nothing here",
    "reservations.row.groupClosed": "Closed",
    "reservations.row.groupIncoming": "Arriving",
    "reservations.row.groupSeated": "Seated",
    "reservations.row.rosterEmptyText": "Confirmed bookings and seated guests will show up here.",
    "reservations.row.rosterEmptyTitle": "No bookings in the roster",
    "reservations.row.statusArrived": "Seated",
    "reservations.row.statusCancelled": "Cancelled",
    "reservations.row.statusDeparted": "Left",
    "reservations.row.statusConfirmed": "Confirmed",
    "reservations.row.statusNoShow": "No-show",
    "reservations.row.statusPending": "Pending",
    "reservations.row.statusRejected": "Rejected",
    "reservations.row.table": "Table {x}",
    "reservations.share.copied": "Copied",
    "reservations.share.copy": "Copy link",
    "reservations.share.intro": "This is the link for your guests to book. Share it on WhatsApp, Instagram, on your menu, wherever you like.",
    "reservations.share.title": "Share booking link",
    "reservations.share.waButton": "Share on WhatsApp",
    "reservations.share.waText": "Book your table here!",
    "reservations.sheet.anyZone": "Any area",
    "reservations.sheet.arrived": "Arrived",
    "reservations.sheet.atTable": "Seated",
    "reservations.sheet.atWhatTime": "What time?",
    "reservations.sheet.durationLabel": "How long?",
    "reservations.sheet.confirm": "Confirm",
    "reservations.sheet.createBooking": "Save booking",
    "reservations.sheet.editTitle": "Edit booking",
    "reservations.sheet.howManyPeople": "How many guests?",
    "reservations.sheet.inWhichZone": "Which area?",
    "reservations.sheet.pickZoneFirst": "Pick a zone first.",
    "reservations.sheet.less": "Less",
    "reservations.sheet.more": "More",
    "reservations.sheet.name": "Name",
    "reservations.sheet.newTitle": "New booking",
    "reservations.sheet.noteOptional": "Note (optional)",
    "reservations.sheet.notePlaceholder": "E.g. birthday, by the window…",
    "reservations.sheet.offline": "Offline — your changes are saved and will sync automatically",
    "reservations.sheet.people": "Guests",
    "reservations.sheet.phone": "Phone",
    "reservations.sheet.phoneOptional": "Phone (optional)",
    "reservations.sheet.reopen": "Reopen",
    "reservations.sheet.saveChanges": "Save changes",
    "reservations.sheet.searchEmpty": "No matches for \"{q}\".",
    "reservations.sheet.searchIntro": "When someone arrives, look them up by name or phone and mark them as arrived.",
    "reservations.sheet.searchPlaceholder": "Name or phone…",
    "reservations.sheet.searchTitle": "Find booking",
    "reservations.sheet.seatN": "Seat {n} guests",
    "reservations.sheet.seatOne": "Seat 1 guest",
    "reservations.sheet.table": "Table",
    "reservations.sheet.tableN": "Table {n}",
    "reservations.sheet.tableOptional": "Table (optional)",
    "reservations.sheet.walkInTitle": "No booking",
    "reservations.row.assignSpot": "Set spot",
    "reservations.sheet.spotTitle": "Which table or spot?",
    "reservations.sheet.spotHint": "Note where you'll seat them so you know when they arrive. Free text.",
    "reservations.sheet.spotPlaceholder": "e.g. Table 5, window, back…",
    "reservations.sheet.spotSave": "Save spot",
    "reservations.sheet.spotClear": "Remove spot",
    "reservations.today.spotSaved": "Spot saved: {spot}",
    "reservations.today.spotCleared": "Spot removed",
    "reservations.sheet.whichTable": "Which table?",
    "reservations.sheet.changeTable": "Change table",
    "reservations.sheet.zone": "Area",
    "reservations.today.activate": "Turn on",
    "reservations.today.backToMenu": "Back to menu",
    "reservations.today.prevDay": "Previous day",
    "reservations.today.nextDay": "Next day",
    "reservations.today.blockTable": "Block table",
    "reservations.today.chipBookings": "Bookings",
    "reservations.today.chipCovers": "Covers",
    "reservations.today.chipSeated": "Seated",
    "reservations.today.disabledNotice": "Bookings off — your guests can't book a table.",
    "reservations.today.emptyArrivingText": "Confirmed bookings still on their way show up here.",
    "reservations.today.emptyArrivingTitle": "No one arriving",
    "reservations.today.emptyClosedText": "No-shows, cancelled and declined bookings show up here.",
    "reservations.today.emptyClosedTitle": "Nothing closed today",
    "reservations.today.emptySeatedText": "Once you mark someone as arrived, they show up here.",
    "reservations.today.emptySeatedTitle": "No one seated yet",
    "reservations.today.live": "Live",
    "reservations.today.liveService": "Live service",
    "reservations.today.loading": "Loading…",
    "reservations.today.navConfig": "Settings",
    "reservations.today.navMonth": "Calendar",
    "reservations.today.navStats": "Stats",
    "reservations.today.newBooking": "Booking",
    "reservations.today.onboardCta": "Get started",
    "reservations.today.onboardSub": "Choose how you want to handle them and turn on the link for your guests.",
    "reservations.today.onboardTitle": "Set up your bookings",
    "reservations.today.search": "Search",
    "reservations.today.shareLink": "Share link",
    "reservations.today.guideTitle": "Learn how it works",
    "reservations.today.guideSub": "Quick guide to the reservations system (PDF)",
    "reservations.today.guideDismiss": "Close",
    "reservations.today.tabArriving": "Arriving",
    "reservations.today.filterAll": "All",
    "reservations.today.filterSoon": "Next hour",
    "reservations.today.filterEmpty": "No bookings for this filter",
    "reservations.today.tabPending": "Pending",
    "reservations.today.tabClosed": "Closed",
    "reservations.today.tabMap": "Map",
    "reservations.today.tabTimeline": "Timeline",
    "reservations.timeline.noTables": "Draw your table map to see the timeline.",
    "reservations.timeline.empty": "No opening hours set for this day.",
    "reservations.timeline.tableShort": "Table",
    "reservations.timeline.blocked": "Blocked",
    "reservations.timeline.hint": "Tap a booking to confirm, mark arrived, etc. The red line is the current time.",
    "reservations.timeline.bookingTitle": "Booking",
    "reservations.today.tabSeated": "Seated",
    "reservations.today.toastSaveError": "Couldn't save the booking",
    "reservations.today.toastUpdateError": "Couldn't update the booking",
    "reservations.today.toastWalkInError": "Couldn't add the walk-in",
    "reservations.today.toastWalkInOk": "Seated (walk-in)",
    "reservations.today.toastWalkInOkAt": "Seated at {where}",
    "reservations.today.toastBookingSaved": "Booking saved",
    "reservations.today.toastBookingUpdated": "Booking updated",
    "reservations.today.toastCancelled": "Booking cancelled",
    "reservations.today.confirmCancel": "Cancel this booking? It's a clean cancellation (doesn't count as a guest no-show).",
    "reservations.today.toConfirm": "To confirm",
    "reservations.today.todayLabel": "Today",
    "reservations.today.walkIn": "Walk-in",
    "reservations.past.title": "Day summary",
    "reservations.past.came": "Showed up",
    "reservations.past.noShow": "No-shows",
    "reservations.past.walkins": "Walk-ins",
    "reservations.past.unmarked": "Unmarked",
    "reservations.past.covers": "Covers",
    "reservations.past.empty": "No bookings this day.",
    "reservations.past.walkinGuest": "Walk-in",
    "reservations.today.walkInSeatAnyway": "Seat them anyway?",
    "reservations.today.walkInTableBusy": "That table is already taken at this time.",
    "reservations.today.walkInZoneFull": "That area is at or near capacity.",
  },
  pt: {
    "reservations.editor.editItem": "Editar item",
    "reservations.editor.done": "Pronto",
    "reservations.dayView.pastBanner": "Dia passado — somente leitura",
    "reservations.dayView.summaryCame": "vieram",
    "reservations.dayView.summaryCovers": "capas",
    "reservations.dayView.summaryNoShow": "não vieram",
    "reservations.dayView.statCovers": "talheres atendidos",
    "reservations.dayView.statReserved": "Reservaram",
    "reservations.dayView.statCame": "Vieram",
    "reservations.dayView.statNoShow": "Não vieram",
    "reservations.dayView.statWalkins": "Da rua",
    "reservations.dayView.pastDetailTitle": "Detalhe do dia",
    "reservations.dayView.walkInTag": "da rua",
    "reservations.dayView.pastEmptyTitle": "Sem reservas nesse dia",
    "reservations.dayView.pastEmptyDesc": "Não houve reservas nem clientes registrados nesta data.",
    "reservations.today.autoAssigned": "Mesa atribuída: {table}",
    "reservations.today.byFranjaLabel": "Talheres por horário",
    "reservations.today.reopenTableTaken": "Essa mesa já está ocupada por outra reserva nesse horário. Reabrir mesmo assim? Você vai precisar reatribuir a mesa.",
    "reservations.today.reopenOver": "Reabrir esta reserva ultrapassa a capacidade desse horário. Reabrir mesmo assim?",
    "reservations.today.confirmReject": "Rejeitar esta reserva? O cliente é avisado no WhatsApp e a reserva é descartada.",
    "reservations.today.confirmNoShow": "Marcar como “não veio”? Libera o lugar para outras reservas.",
    "reservations.today.confirmSilent": "Confirmar SEM avisar o cliente pelo WhatsApp? Ele não fica sabendo.",
    "reservations.zoneSheet.empty": "Ninguém nesta área ainda",
    "reservations.zoneSheet.walkIn": "Sentar walk-in aqui",
    "reservations.config.previewAsClient": "Ver como cliente",
    "reservations.config.waInvalid": "Parece incompleto. Inclua o código do país (ex: 55119…).",
    "reservations.config.needZone": "Adicione ao menos uma zona ou mude o modo para Agenda.",
    "reservations.config.waPreview": "Será usado: {n}",
    "reservations.config.detailsTitle": "Detalhes da reserva",
    "reservations.config.durationTitle": "Duração de cada reserva",
    "reservations.config.durationHint": "Quanto tempo a mesa fica reservada. Evita sobrepor reservas na mesma faixa.",
    "reservations.config.slotIntervalTitle": "De quanto em quanto tempo podem reservar (horário livre)",
    "reservations.config.slotIntervalHint": "O intervalo entre os horários que o cliente vê. Ex.: a cada 30 min oferece 20:00, 20:30, 21:00… (em vez de a cada 15). Só vale para os dias em modo \"horário livre\".",
    "reservations.config.everyN": "A cada {n}",
    "reservations.config.intervalAny": "Qualquer horário",
    "reservations.book.openHoursHint": "Horário de atendimento: {hours}",
    "reservations.book.outOfHoursPick": "Esse horário está fora do horário de atendimento. Escolha um dentro.",
    "reservations.book.tooSoonPick": "Esse horário já passou ou é muito cedo. Escolha um mais tarde.",
    "reservations.config.minAdvanceTitle": "Antecedência mínima para reservar",
    "reservations.config.minAdvanceHint": "Com quanta antecedência mínima podem reservar para hoje. Horários que já passaram nunca aparecem.",
    "reservations.config.advanceNone": "Sem mínimo",
    "reservations.config.advanceDay": "1 dia",
    "reservations.config.windowTitle": "Com quanta antecedência podem reservar",
    "reservations.config.windowHint": "Até quantos dias à frente seus clientes podem reservar.",
    "reservations.config.capacityTitle": "Limite de pessoas em simultâneo",
    "reservations.config.capacityHint": "Teto de talheres ao mesmo tempo. 0 = sem limite. Avisamos ao confirmar/adicionar se ultrapassar.",
    "reservations.config.capacityPlaceholder": "Sem limite",
    "reservations.config.daysUnit": "dias",
    "reservations.alert.aria": "Nova reserva",
    "reservations.alert.more": "(+{n} mais)",
    "reservations.alert.title": "Nova reserva!",
    "reservations.book.anyZone": "Qualquer área / tanto faz",
    "reservations.book.approxDuration": "(aprox. {n} min)",
    "reservations.book.heldRange": "Guardamos o horário das {start} às {end}",
    "reservations.book.consultCta": "Não achou lugar ou horário? Fale com a gente",
    "reservations.today.tightTurnaroundWarn": "Esta mesa fica muito colada a outra reserva (pouca margem para preparar). Confirmar mesmo assim?",
    "reservations.today.pendingOtherDays": "⏳ {n} para confirmar de outros dias",
    "reservations.today.pendingSheetTitle": "Reservas para confirmar",
    "reservations.today.pendingSheetEmpty": "Nenhuma reserva para confirmar.",
    "reservations.book.consultWaMessage": "Olá! Gostaria de consultar a disponibilidade para uma reserva 🙌",
    "reservations.book.expand": "Ampliar",
    "reservations.book.enlarge": "Ampliar",
    "reservations.tableGrid.tableN": "Mesa {n}",
    "reservations.nav.today": "Hoje",
    "reservations.nav.calendar": "Calendário",
    "reservations.nav.tables": "Mesas",
    "reservations.nav.summary": "Resumo",
    "reservations.nav.clients": "Clientes",
    "reservations.clients.title": "Clientes",
    "reservations.clients.subtitle": "Sua base de clientes",
    "reservations.clients.count": "{n} clientes",
    "reservations.clients.searchPh": "Buscar por nome ou telefone",
    "reservations.clients.empty": "Ainda não há clientes. Eles aparecem sozinhos conforme você recebe reservas.",
    "reservations.clients.noMatch": "Nenhum cliente corresponde à busca.",
    "reservations.clients.visits": "Visitas",
    "reservations.clients.noShows": "Não veio",
    "reservations.clients.covers": "Cobertos",
    "reservations.clients.visitsN": "{n} visitas",
    "reservations.clients.noShowN": "{n} não veio",
    "reservations.clients.last": "última: {date}",
    "reservations.clients.lastVisit": "Última visita",
    "reservations.clients.wa": "WhatsApp",
    "reservations.clients.call": "Ligar",
    "reservations.clients.makeVip": "VIP",
    "reservations.clients.notes": "Notas",
    "reservations.clients.notesPh": "Ex: mesa preferida, cliente habitual, alérgico a…",
    "reservations.clients.save": "Salvar nota",
    "reservations.clients.saved": "Salvo",
    "reservations.clients.saveError": "Não foi possível salvar",
    "reservations.clients.waHi": "Olá! 👋",
    "reservations.waitlist.open": "Lista de espera",
    "reservations.waitlist.title": "Lista de espera",
    "reservations.waitlist.nameLabel": "Nome (opcional)",
    "reservations.waitlist.phoneLabel": "Telefone para avisar (opcional)",
    "reservations.waitlist.namePh": "Ex: Lucas",
    "reservations.waitlist.phonePh": "Ex: +55 11 99999 9999",
    "reservations.waitlist.add": "Adicionar à espera",
    "reservations.waitlist.empty": "Ninguém esperando. Adicione quem ficou sem mesa.",
    "reservations.waitlist.guest": "Sem nome",
    "reservations.waitlist.notify": "Avisar",
    "reservations.waitlist.waitedMin": "há {n} min",
    "reservations.waitlist.waMsg": "Olá{name}! Liberou uma mesa em {place}. Ainda tem interesse? Avise 🙌",
    "reservations.manage.eyebrow": "Sua reserva",
    "reservations.manage.yourBooking": "Sua reserva",
    "reservations.manage.loading": "Carregando…",
    "reservations.manage.invalidTitle": "Link inválido",
    "reservations.manage.invalidDesc": "Este link não é válido ou a reserva não existe mais. Se precisar, escreva no WhatsApp.",
    "reservations.manage.date": "Data",
    "reservations.manage.time": "Hora",
    "reservations.manage.people": "Pessoas",
    "reservations.manage.table": "Mesa",
    "reservations.manage.confirmCta": "Confirmar presença",
    "reservations.manage.cancelCta": "Cancelar reserva",
    "reservations.manage.cancelConfirm": "Tem certeza de que quer cancelar sua reserva?\n\nAssim que confirmar, o WhatsApp vai abrir com uma mensagem pronta para avisar o restaurante. Por favor, entre e envie essa mensagem.",
    "reservations.manage.cancelledMsg": "Sua reserva foi cancelada. Obrigado por avisar!",
    "reservations.manage.notifyRestaurant": "Avisar o restaurante",
    "reservations.manage.cancelWaHeadsUp": "Abrimos o WhatsApp para você avisar o restaurante 👇 Por favor, envie a mensagem (não feche sem enviar).",
    "reservations.manage.cancelWaMessage": "Oi! Cancelei minha reserva em nome de {name} para {date} às {time} ({people} pessoas). Obrigado!",
    "reservations.manage.confirmedMsg": "Pronto! Você confirmou sua reserva. Até logo 🙌",
    "reservations.manage.error": "Não foi possível processar. Tente de novo.",
    "reservations.nav.settings": "Config",
    "reservations.book.placePhotosTitle": "Conheça o lugar",
    "reservations.book.placePhotosHint": "Toque uma foto para vê-la grande. Deslize entre todas.",
    "reservations.book.sector": "Setor",
    "reservations.book.photoFailed": "Não foi possível carregar a foto.",
    "reservations.book.legendFree": "Livre (toque para escolher)",
    "reservations.book.legendChosen": "Sua mesa",
    "reservations.book.legendTooSmall": "Não cabe seu grupo",
    "reservations.book.viewPhoto": "Ver foto",
    "reservations.book.legendUnavailable": "Indisponível",
    "reservations.book.zoneStep": "Em qual área?",
    "reservations.config.chosen": "Você escolheu: {mode}",
    "reservations.config.enabledHint": "Quando está ativo, seus clientes podem reservar pelo link público.",
    "reservations.config.enabledTitle": "Reservas ativas",
    "reservations.config.groupPage": "Sua página de reservas",
    "reservations.config.groupPageDesc": "O que seu cliente vê ao abrir o link para reservar.",
    "reservations.config.groupSpace": "Como você organiza o lugar",
    "reservations.config.groupSpaceDesc": "Escolha como recebe as reservas: lista simples, por área ou com mapa de mesas.",
    "reservations.config.groupHours": "Quando você abre",
    "reservations.config.groupHoursDesc": "Seus horários de atendimento, os dias que fecha e os feriados que abre.",
    "reservations.config.advanced": "Ajustes avançados",
    "reservations.config.leaveUnsaved": "Você tem alterações não salvas. Sair mesmo assim e perdê-las?",
    "reservations.config.photoTitle": "Logo do local",
    "reservations.config.photoHint": "Aparece no topo da sua página de reservas. Envie o logo do seu local.",
    "reservations.config.photoAdd": "Enviar logo",
    "reservations.config.photoChange": "Trocar logo",
    "reservations.config.photoRemove": "Remover",
    "reservations.config.uploading": "Enviando…",
    "reservations.config.mode.agendaExample": "Você tem um bar ou café pequeno. Mandam \"mesa para 4 às 21h\" e fica só anotado. Você vê a lista do dia e marca quem chegou com um toque. Nada mais.",
    "reservations.config.mode.agendaNeeds": "Não precisa configurar mais nada.",
    "reservations.config.mode.agendaShort": "Você só anota quem vem. Sem mapa nem mesas.",
    "reservations.config.mode.agendaTitle": "Agenda simples",
    "reservations.config.mode.hide": "Ocultar",
    "reservations.config.mode.showHow": "Ver como funciona",
    "reservations.config.mode.tablesExample": "Seu salão é fixo. Você desenha a planta uma vez. O cliente pode pedir uma mesa específica e você atribui uma a cada reserva. Vê o mapa com as mesas livres e ocupadas ao vivo.",
    "reservations.config.mode.tablesNeeds": "Você desenha a planta das mesas uma única vez.",
    "reservations.config.mode.tablesShort": "Cada reserva fica vinculada a uma mesa específica da planta.",
    "reservations.config.mode.tablesTitle": "Mesas fixas",
    "reservations.config.mode.zonesExample": "Você muda as mesas conforme o dia. O cliente pede \"4 pessoas no deck\". Você vê quanto lugar sobra em cada área e confirma se dá para montar algo. A reserva fica vinculada à área, não a uma mesa.",
    "reservations.config.mode.zonesNeeds": "Você define suas áreas e, se quiser, a capacidade delas.",
    "reservations.config.mode.zonesShort": "Você reserva por área (deck, salão, pátio) e monta as mesas.",
    "reservations.config.mode.zonesTitle": "Por áreas",
    "reservations.config.openMapEditor": "Abrir editor de planta",
    "reservations.config.spaceModeHint": "Como você gerencia o espaço. Mudar não apaga as reservas existentes.",
    "reservations.config.confirmModeChange": "Mudar o modo de reservas? Mesas/zonas e reservas configuradas no modo atual podem deixar de aparecer. As reservas não são apagadas.",
    "reservations.config.spaceModeTitle": "Modo de reservas",
    "reservations.config.start": "Começar",
    "reservations.config.tablesHint": "Monte o seu salão: mesas, capacidade e posição.",
    "reservations.config.tablesTitle": "Planta das mesas",
    "reservations.config.welcomeSub": "Escolha o modo que mais combina com o seu jeito de trabalhar. Você pode mudar depois sem perder nada.",
    "reservations.config.welcomeTitle": "Como você prefere administrar suas reservas?",
    "reservations.config.zones.addPhoto": "Adicionar foto",
    "reservations.config.zones.addZone": "Adicionar área",
    "reservations.config.zones.empty": "Você ainda não tem áreas. Adicione as que usa (Deck, Salão, Pátio…).",
    "reservations.config.zones.hint": "A capacidade é opcional: se você definir, avisamos quando uma área passa do limite (não bloqueia — você decide). O cliente vê a foto ao escolher a área.",
    "reservations.config.zones.namePlaceholder": "Nome da área",
    "reservations.config.zones.confirmDelete": "Apagar esta área? As reservas que já estão nela não são apagadas.",
    "reservations.config.zones.peopleUnit": "pess.",
    "reservations.config.zones.photoAlt": "área",
    "reservations.config.zones.removePhoto": "Remover foto",
    "reservations.config.zones.removeZone": "Excluir área",
    "reservations.config.zones.sectionHint": "Os lugares onde você acomoda os clientes (Deck, Salão, Pátio…).",
    "reservations.config.zones.sectionTitle": "Suas áreas",
    "reservations.config.zones.uploading": "Enviando…",
    "reservations.map.legendFree": "Livre",
    "reservations.map.legendOccupied": "Ocupada",
    "reservations.map.legendPending": "Pendente",
    "reservations.map.legendReserved": "Reservada",
    "reservations.map.noFloorPlanDesc": "Vá em Configurações → Mapa de mesas para criá-lo.",
    "reservations.map.noFloorPlanTitle": "Você ainda não desenhou seu salão",
    "reservations.map.noZonesDesc": "Vá em Configurações → Suas áreas para criá-las.",
    "reservations.map.noZonesTitle": "Você ainda não definiu áreas",
    "reservations.map.zoneCapacity": "{used} / {cap} pessoas",
    "reservations.map.zoneUsage": "{people} pessoas · {parties} grupos",
    "reservations.row.actionArrived": "Chegou",
    "reservations.row.actionConfirm": "Confirmar",
    "reservations.row.actionConfirmNotify": "Confirmar e avisar",
    "reservations.row.actionConfirmSilent": "Confirmar sem avisar",
    "reservations.row.noteLabel": "Observação",
    "reservations.row.actionEdit": "Editar",
    "reservations.row.actionFree": "Liberar mesa",
    "reservations.row.actionNoShow": "Não veio",
    "reservations.row.actionReject": "Recusar",
    "reservations.row.actionRemind": "Lembrar",
    "reservations.row.actionAssign": "Mesa",
    "reservations.row.actionCancel": "Cancelar",
    "reservations.row.actionReopen": "Recuperar",
    "reservations.row.anyZone": "Qualquer área",
    "reservations.row.badgeMissed": "faltou {n}",
    "reservations.row.badgeCollision": "Conflito com {name} (mesma mesa e horário)",
    "reservations.row.badgeNew": "nova",
    "reservations.row.confirmedByGuest": "confirmou",
    "reservations.row.confirmedByGuestHint": "O cliente confirmou presença pelo link que você enviou.",
    "reservations.row.emptyTitle": "Nada por aqui",
    "reservations.row.groupClosed": "Fechadas",
    "reservations.row.groupIncoming": "A chegar",
    "reservations.row.groupSeated": "Na mesa",
    "reservations.row.rosterEmptyText": "As reservas confirmadas e quem já está na mesa vão aparecer aqui.",
    "reservations.row.rosterEmptyTitle": "Sem reservas na lista",
    "reservations.row.statusArrived": "Na mesa",
    "reservations.row.statusCancelled": "Cancelada",
    "reservations.row.statusDeparted": "Saiu",
    "reservations.row.statusConfirmed": "Confirmada",
    "reservations.row.statusNoShow": "Não veio",
    "reservations.row.statusPending": "Pendente",
    "reservations.row.statusRejected": "Recusada",
    "reservations.row.table": "Mesa {x}",
    "reservations.share.copied": "Copiado",
    "reservations.share.copy": "Copiar link",
    "reservations.share.intro": "Este é o link para seus clientes reservarem. Compartilhe pelo WhatsApp, Instagram, no seu cardápio, onde quiser.",
    "reservations.share.title": "Compartilhar link de reservas",
    "reservations.share.waButton": "Compartilhar pelo WhatsApp",
    "reservations.share.waText": "Reserve sua mesa aqui!",
    "reservations.sheet.anyZone": "Qualquer área",
    "reservations.sheet.arrived": "Chegou",
    "reservations.sheet.atTable": "Na mesa",
    "reservations.sheet.atWhatTime": "A que horas?",
    "reservations.sheet.durationLabel": "Quanto dura?",
    "reservations.sheet.confirm": "Confirmar",
    "reservations.sheet.createBooking": "Salvar reserva",
    "reservations.sheet.editTitle": "Editar reserva",
    "reservations.sheet.howManyPeople": "Quantas pessoas?",
    "reservations.sheet.inWhichZone": "Em qual área?",
    "reservations.sheet.pickZoneFirst": "Escolha a zona primeiro.",
    "reservations.sheet.less": "Menos",
    "reservations.sheet.more": "Mais",
    "reservations.sheet.name": "Nome",
    "reservations.sheet.newTitle": "Nova reserva",
    "reservations.sheet.noteOptional": "Observação (opcional)",
    "reservations.sheet.notePlaceholder": "Ex: aniversário, perto da janela…",
    "reservations.sheet.offline": "Sem conexão — as alterações são salvas e sincronizam sozinhas",
    "reservations.sheet.people": "Pessoas",
    "reservations.sheet.phone": "Telefone",
    "reservations.sheet.phoneOptional": "Telefone (opcional)",
    "reservations.sheet.reopen": "Reabrir",
    "reservations.sheet.saveChanges": "Salvar alterações",
    "reservations.sheet.searchEmpty": "Nada encontrado para \"{q}\".",
    "reservations.sheet.searchIntro": "Quando alguém chega, busque pelo nome ou telefone e marque que chegou.",
    "reservations.sheet.searchPlaceholder": "Nome ou telefone…",
    "reservations.sheet.searchTitle": "Buscar reserva",
    "reservations.sheet.seatN": "Sentar {n} pessoas",
    "reservations.sheet.seatOne": "Sentar 1 pessoa",
    "reservations.sheet.table": "Mesa",
    "reservations.sheet.tableN": "Mesa {n}",
    "reservations.sheet.tableOptional": "Mesa (opcional)",
    "reservations.sheet.walkInTitle": "Sem reserva",
    "reservations.row.assignSpot": "Definir lugar",
    "reservations.sheet.spotTitle": "Em qual mesa ou lugar?",
    "reservations.sheet.spotHint": "Anote onde vai sentar para lembrar quando chegar. Texto livre.",
    "reservations.sheet.spotPlaceholder": "Ex: Mesa 5, janela, fundo…",
    "reservations.sheet.spotSave": "Salvar lugar",
    "reservations.sheet.spotClear": "Tirar o lugar",
    "reservations.today.spotSaved": "Lugar salvo: {spot}",
    "reservations.today.spotCleared": "Lugar removido",
    "reservations.sheet.whichTable": "Qual mesa?",
    "reservations.sheet.changeTable": "Trocar mesa",
    "reservations.sheet.zone": "Área",
    "reservations.today.activate": "Ativar",
    "reservations.today.backToMenu": "Voltar ao cardápio",
    "reservations.today.prevDay": "Dia anterior",
    "reservations.today.nextDay": "Próximo dia",
    "reservations.today.blockTable": "Bloquear mesa",
    "reservations.today.chipBookings": "Reservas",
    "reservations.today.chipCovers": "Talheres",
    "reservations.today.chipSeated": "Na mesa",
    "reservations.today.disabledNotice": "Reservas desativadas — seus clientes não podem reservar.",
    "reservations.today.emptyArrivingText": "As reservas confirmadas que ainda faltam chegar aparecem aqui.",
    "reservations.today.emptyArrivingTitle": "Ninguém a chegar",
    "reservations.today.emptyClosedText": "No-shows, canceladas e recusadas aparecem aqui.",
    "reservations.today.emptyClosedTitle": "Nenhuma encerrada hoje",
    "reservations.today.emptySeatedText": "Quando marcar que alguém chegou, aparece aqui.",
    "reservations.today.emptySeatedTitle": "Ninguém na mesa",
    "reservations.today.live": "Ao vivo",
    "reservations.today.liveService": "Serviço ao vivo",
    "reservations.today.loading": "Carregando…",
    "reservations.today.navConfig": "Config",
    "reservations.today.navMonth": "Calendário",
    "reservations.today.navStats": "Métricas",
    "reservations.today.newBooking": "Reserva",
    "reservations.today.onboardCta": "Começar",
    "reservations.today.onboardSub": "Escolha como quer gerenciá-las e ative o link para seus clientes.",
    "reservations.today.onboardTitle": "Configure suas reservas",
    "reservations.today.search": "Buscar",
    "reservations.today.shareLink": "Compartilhar link",
    "reservations.today.guideTitle": "Descubra como usar",
    "reservations.today.guideSub": "Guia rápido do sistema de reservas (PDF)",
    "reservations.today.guideDismiss": "Fechar",
    "reservations.today.tabArriving": "A chegar",
    "reservations.today.filterAll": "Todas",
    "reservations.today.filterSoon": "Próxima hora",
    "reservations.today.filterEmpty": "Nenhuma reserva com este filtro",
    "reservations.today.tabPending": "Pendentes",
    "reservations.today.tabClosed": "Encerradas",
    "reservations.today.tabMap": "Mapa",
    "reservations.today.tabTimeline": "Linha",
    "reservations.timeline.noTables": "Desenhe seu mapa de mesas para ver a linha do tempo.",
    "reservations.timeline.empty": "Sem horário configurado para este dia.",
    "reservations.timeline.tableShort": "Mesa",
    "reservations.timeline.blocked": "Bloqueada",
    "reservations.timeline.hint": "Toque uma reserva para confirmar, marcar chegada, etc. A linha vermelha é o horário atual.",
    "reservations.timeline.bookingTitle": "Reserva",
    "reservations.today.tabSeated": "Na mesa",
    "reservations.today.toastSaveError": "Não foi possível salvar a reserva",
    "reservations.today.toastUpdateError": "Não foi possível atualizar a reserva",
    "reservations.today.toastWalkInError": "Não foi possível registrar o walk-in",
    "reservations.today.toastWalkInOk": "Sentado sem reserva",
    "reservations.today.toastWalkInOkAt": "Sentado em {where}",
    "reservations.today.toastBookingSaved": "Reserva salva",
    "reservations.today.toastBookingUpdated": "Reserva atualizada",
    "reservations.today.toastCancelled": "Reserva cancelada",
    "reservations.today.confirmCancel": "Cancelar esta reserva? É um cancelamento limpo (não conta como falta do cliente).",
    "reservations.today.toConfirm": "A confirmar",
    "reservations.today.todayLabel": "Hoje",
    "reservations.today.walkIn": "Sem reserva",
    "reservations.past.title": "Resumo do dia",
    "reservations.past.came": "Vieram",
    "reservations.past.noShow": "Não vieram",
    "reservations.past.walkins": "Sem reserva",
    "reservations.past.unmarked": "Sem marcar",
    "reservations.past.covers": "Cobertos",
    "reservations.past.empty": "Não houve reservas neste dia.",
    "reservations.past.walkinGuest": "Sem reserva",
    "reservations.today.walkInSeatAnyway": "Sentar mesmo assim?",
    "reservations.today.walkInTableBusy": "Essa mesa já está ocupada neste horário.",
    "reservations.today.walkInZoneFull": "Essa zona está perto ou acima da capacidade.",
  },
};
export default reservationsNew;
